import { Navigate, useLocation } from 'react-router-dom';
import useAuth from './useAuth';

export default function ProtectedRoute({ children }) {
  const { token, user } = useAuth();
  const { pathname } = useLocation();

  if (!token) return <Navigate to="/login" replace />;

  // Until the business details are given, the API refuses everything else
  // (see RequireOnboarding), so every page behind this would be an empty one
  // full of errors. Sending them to the stepper is the readable version of the
  // same rule.
  //
  // Only once /me has answered, and only when it actually says no: a missing
  // flag — an older payload, a response still in flight — must never strand
  // somebody on a setup screen they have already finished.
  const onboarded = user?.restaurant?.onboarding_complete;

  if (user && onboarded === false && pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
